import { type PropsWithChildren } from 'react'

export function ScreenContainer({ children }: PropsWithChildren) {
  return <div className='relative flex h-full w-full flex-1 flex-col bg-[#141414]'>{children}</div>
}
